import React, {useState, useEffect} from 'react'
import './footer.css'
import foot from '../../main_assets/foot.png';
import foot2 from '../../main_assets/foot2.png';
import link1 from '../../main_assets/star.png'; 
import { FaStar } from 'react-icons/fa';

const Footer = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  
  const shareUrl = 'https://your-website-url.com';
  const title = 'Check out our awesome website!';

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleShareButtonClick = () => {
    openModal();
  };

  const handleModalClose = () => {
    closeModal();
    document.body.classList.remove('popup-open');
  };

  const handleModalOpen = () => {
    openModal();
    document.body.classList.add('popup-open');
  };

  useEffect(() => {
    const handleBodyScroll = () => {
      if (isModalOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    handleBodyScroll(); 
    window.addEventListener('scroll', handleBodyScroll);
    return () => {
      window.removeEventListener('scroll', handleBodyScroll); 
    };
  }, [isModalOpen]);

  const handleNewsletterSignup = () => {
    console.log(`Email submitted: ${email}`);
  };

  return (
    <>
      <div className="ulev__footer">
        <div className="ulev__footer-btn">
          <div className='img'>
            <img src={foot2} alt="logo" className="ulev__footer-btn-image" />
          </div>
          <div className='img'>
            <img src={foot} alt="logo" className="ulev__footer-btn-image" />
          </div>
        </div>
        
      </div>
      <div className="ulev__footer-container">
        <div className="ulev__footer-links">
          <div className="ulev__footer-column">
            <ul>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Home</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Case Studies</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Featured</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Top Picks</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Highlights</a>
              </li>
            </ul>
          </div>

          {/* Additional Links Column */}
          <div className="ulev__footer-column">
            {/* <h4>Quick Links</h4> */}
            <div className="ulev__footer-column">
            <ul>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">About Us</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Contact</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">Terms of Service</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="#">FAQ</a>
              </li>
            </ul>
          </div>

          </div>

          {/* Social Media Links Column */}
          <div className="ulev__footer-column">
            {/* <h4>Follow Us</h4> */}
            <ul>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="https://www.instagram.com/thisisulevus/" target="_blank" rel="noopener noreferrer">Instagram</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="https://www.linkedin.com/company/ulevus/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="https://twitter.com/thisisulevus/" target="_blank" rel="noopener noreferrer">Twitter</a>
              </li>
              <li>
                <img src={link1} alt="star" className="star-icon" />
                <a href="https://web.facebook.com/thisisulevus/" target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
            </ul>
          </div>

          {/* Newsletter Signup Section fixed at bottom */}
          <div className="ulev__footer-newsletter">
            <h4>Subscribe to our newsletter</h4>
            <div className="newsletter-input-container">
              <input type="email" placeholder="" required />
              <button type="submit" aria-label="Subscribe">
                <span className="arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Footer

